import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useCreateMeasurement } from "@/api/grass";
import { PageHeader } from "@/components/PageHeader";
import { MeasurementForm } from "./-components/MeasurementForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new",
)({
	// Self-contained form; the create queues offline (paddock-measurements:create).
	staticData: { offline: "ready" },
	component: NewMeasurementPage,
});

function NewMeasurementPage() {
	const { orgId, farmId, paddockId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();

	const createMutation = useCreateMeasurement();

	const handleSubmit = (
		data: Parameters<typeof createMutation.mutate>[0]["data"],
	) =>
		createMutation
			.mutateAsync({
				organizationId: orgId,
				establishmentId: farmId,
				paddockId,
				data,
			})
			.then(() => {
				navigate({
					to: "/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId",
					params: { orgId, farmId, paddockId },
				});
			});

	return (
		<div className="flex flex-col gap-6">
			<PageHeader title={t("grass.measurement.create.title")} showBackButton />
			<div className="card bg-base-100 shadow-md">
				<div className="card-body">
					<MeasurementForm
						onSubmit={handleSubmit}
						isSubmitting={createMutation.isPending}
					/>
				</div>
			</div>
		</div>
	);
}
